module.exports = __webpack_public_path__ + "media/images/common/ico-rank-1-83ec624f7b12484bf49b41037f50503a.svg";